import { createSdkMock } from './createSdkMock/createSdkMock';
import { guessParams } from './guessParams';
import { patch } from './utils/patch';
export function patchWixSdk(sdk, params) {
    if (!params) {
        params = guessParams();
        if (!params) {
            console.warn('Could not guess params. js-sdk is not patched');
            return;
        }
    }
    var mock = createSdkMock(params);
    patch(sdk, mock);
}
//# sourceMappingURL=patchWixSdk.js.map